import React, { Component } from "react";
import { message } from "../../../../../utils/sysManagementUtils";
import BaseComponent from "../../../../../../../base/BaseComponent";
import UploadWall from "../../../../../../../components/upload/UploadWall";
import {ATTCHMENT_TYPE_ORIGINAL,ATTCHMENT_TYPE} from "../../../../../../../constants";

export default class FileUpload extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            fileList: [
            ],
            loading: false,
            maxSize:"",
        };
    }

    componentWillMount() {
        this.state.maxSize=window.sysConfig.getValueByKey('uploadFileMaxSize', 20);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.value && this.props.value !== prevProps.value) {
            this.getStorageFileList(this.props.value);
        }
    }

    componentDidMount() {
        if (this.props.value) {
            this.getStorageFileList(this.props.value);
        }
    }

    render() {
        const { fileList } = this.state;
        const accept = ATTCHMENT_TYPE_ORIGINAL.map(item => "." + item).join(',');
        return (
            <UploadWall
                multiple={false}
                accept={accept}
                action="/dynamic/storage/uploadFile"
                showUploadBtn={true}
                fileList={fileList}
                listType="list"
                onChange={this.handleChange}
                beforeUpload={this.handleBeforeUpload}
                onDownload={(file) => {
                    window.open(`/storage/downloadFile?md5=${file.url}&download=1`)
                }}
                onRemove={this.onRemove}
                describe={"支持txt、doc、xls、ppt、docx、xlsx、pptx等常见格式文件上传，文件最大限制不超过"+this.state.maxSize+"M"}
            />
        );
    }
    //上传前添加上传提示，限制非格式的上传
    handleBeforeUpload = (file, fileList) => {
        let fileName = file.name.split('.');
        let upload = fileName.at(-1).toUpperCase();
        upload = ATTCHMENT_TYPE.includes(upload);

        let fileSize = file.size/1024/1024; // mb
        let beyondTheSize = fileSize>this.state.maxSize;
        if(beyondTheSize) {
            message.error("文件最大限制不超过"+this.state.maxSize+"M");
        }
        if(!upload){
            message.error('暂不支持该文件类型！');
        }
        return new Promise((resolve, reject) => {
            if (!upload || beyondTheSize) {
                reject(file);
            } else {
                resolve(file);
            }
        });
    }
    onRemove = file => {
        let { fileList } = this.state
        fileList = fileList.filter(item => item.uid !== file.uid)
        this.props.onChange('');
        this.setState({
            fileList
        })
    }

    handleChange = info => {
        let fileList = [...info.fileList];
        fileList = fileList.slice(-1);
       let accept = "." + [...ATTCHMENT_TYPE_ORIGINAL].join(",.");
        fileList = fileList.map(file => {
            if (file.status === "done") {
                if (file.response && file.response.data) {
                    file.url = file.response.data.md5;
                    this.props.onChange(file.response.data.md5);
                    message.success("文件上传成功");
                } else {
                    file.status = "error"
                    message.error('暂不支持该文件类型!');
                }
            } else if (file.status === "error") {
                message.info('只支持'+accept+'格式');
            }
            return file;
        });
        this.setState({ fileList });
    };

    // /storage/getStorageFileList
    getStorageFileList = md5s => {
        this.request({
            url: "/storage/getStorageFileList",
            body: { md5s },
            callBack: res => {
                if (res) {
                    this.setState({
                        fileList: [
                            {
                                uid: res[0]._id,
                                name: res[0].name,
                                status: "done",
                                url: res[0].md5
                            }
                        ]
                    });
                }
            }
        });
    }
}

